'use strict';

// Adds accessibile labels to Query Block more link
let read_mores = document.querySelectorAll('.wp-block-post-excerpt__more-link');
read_mores.forEach( link => {
    let post_title = link.closest('.wp-block-post').querySelector('.wp-block-post-title').innerText;
    link.setAttribute( 'aria-label', 'Read more about ' + post_title );
});

// Force aria labels (if they exist) to act as title for iframes
document.querySelectorAll('iframe').forEach(function(frame) {
    var ariaLabel = frame.getAttribute('aria-label');
    var hasTitle = frame.hasAttribute('title');

    if (ariaLabel && !hasTitle) {
        frame.setAttribute('title', ariaLabel);
    }

    frame.removeAttribute('aria-label');
});

// Add tabindex and role to all links
let links = document.querySelectorAll('a');
links.forEach(link => {
    link.setAttribute( 'tabindex', '0' );
    link.setAttribute( 'role', 'link' );
});

// WCAG: Add pause/play controls to auto-playing swipers (Greenshift gs-swiper-init)
document.addEventListener('DOMContentLoaded', () => {
    // Greenshift initializes swipers with a slight delay, so we use MutationObserver or a small timeout.
    // For simplicity and reliability with third-party blocks, a brief timeout after DOM ready ensures Swiper is attached.
    setTimeout(() => {
        const swiperContainers = document.querySelectorAll('.gs-swiper-init');
        
        swiperContainers.forEach(container => {
            // WCAG Fix 4.1.2: Remove incorrect role="link" and aria-label from slides
            const fixSlideA11y = (slide) => {
                if (slide.getAttribute('role') === 'link') {
                    slide.removeAttribute('role');
                }
                if (slide.hasAttribute('aria-label') && slide.getAttribute('aria-label').match(/^\d+\s*\/\s*\d+$/)) {
                    slide.removeAttribute('aria-label');
                }
            };
            
            container.querySelectorAll('.swiper-slide').forEach(fixSlideA11y);

            // Observe for newly created slides or attribute resets by Swiper
            const slideObserver = new MutationObserver((mutations) => {
                mutations.forEach(mutation => {
                    if (mutation.type === 'childList') {
                        mutation.addedNodes.forEach(node => {
                            if (node.nodeType === 1 && node.classList.contains('swiper-slide')) {
                                fixSlideA11y(node);
                            }
                        });
                    }
                    if (mutation.type === 'attributes') {
                        const target = mutation.target;
                        if (target.classList && target.classList.contains('swiper-slide')) {
                            fixSlideA11y(target);
                        }
                    }
                });
            });
            
            const swiperWrapper = container.querySelector('.swiper-wrapper');
            if (swiperWrapper) {
                slideObserver.observe(swiperWrapper, { childList: true, subtree: true, attributes: true, attributeFilter: ['role', 'aria-label'] });
            }

            const isAutoplay = container.getAttribute('data-autoplay') === 'true';
            if (!isAutoplay) return;
            
            // Check if swiper instance exists
            const swiperEl = container.querySelector('.swiper');
            if (!swiperEl || !swiperEl.swiper || !swiperEl.swiper.autoplay) return;

            // Create pause/play button
            const btn = document.createElement('button');
            btn.className = 'a11y-swiper-toggle';
            btn.setAttribute('aria-label', 'Pause animation');
            btn.setAttribute('aria-pressed', 'false');
            
            // Using a simple CSS-based icon or SVG
            btn.innerHTML = `
                <svg class="icon-pause" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                    <path d="M6 19H10V5H6V19ZM14 5V19H18V5H14Z" fill="currentColor"/>
                </svg>
                <svg class="icon-play" style="display:none;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                    <path d="M8 5V19L19 12L8 5Z" fill="currentColor"/>
                </svg>
            `;
            
            container.style.position = 'relative'; // Ensure button is positioned relative to container
            container.appendChild(btn);

            let isPaused = false;

            // Check for prefers-reduced-motion
            const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (prefersReducedMotion) {
                swiperEl.swiper.autoplay.stop();
                btn.setAttribute('aria-label', 'Play animation');
                btn.setAttribute('aria-pressed', 'true');
                btn.querySelector('.icon-pause').style.display = 'none';
                btn.querySelector('.icon-play').style.display = 'block';
                isPaused = true;
            }
            
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                if (isPaused) {
                    swiperEl.swiper.autoplay.start();
                    btn.setAttribute('aria-label', 'Pause animation');
                    btn.setAttribute('aria-pressed', 'false');
                    btn.querySelector('.icon-pause').style.display = 'block';
                    btn.querySelector('.icon-play').style.display = 'none';
                    isPaused = false;
                } else {
                    swiperEl.swiper.autoplay.stop();
                    btn.setAttribute('aria-label', 'Play animation');
                    btn.setAttribute('aria-pressed', 'true');
                    btn.querySelector('.icon-pause').style.display = 'none';
                    btn.querySelector('.icon-play').style.display = 'block';
                    isPaused = true;
                }
            });
            
            // WCAG Recommendation: Pause on focus/hover as well if it contains interactive elements
            container.addEventListener('mouseenter', () => {
                if (!isPaused) swiperEl.swiper.autoplay.stop();
            });
            container.addEventListener('mouseleave', () => {
                if (!isPaused) swiperEl.swiper.autoplay.start();
            });
            container.addEventListener('focusin', () => {
                if (!isPaused) swiperEl.swiper.autoplay.stop();
            });
            container.addEventListener('focusout', () => {
                if (!isPaused) swiperEl.swiper.autoplay.start();
            });
        });
    }, 1500); // 1.5s delay to ensure swiper initialization is complete
});

// WCAG: Ensure unique aria-labels for submenu toggle buttons and update dynamically
document.addEventListener('DOMContentLoaded', () => {
    const submenuButtons = document.querySelectorAll('button[aria-label="Expand dropdown menu"], .ct-toggle-dropdown-desktop-ghost, .ct-toggle-dropdown-mobile');
    submenuButtons.forEach(btn => {
        const parentLi = btn.closest('li');
        if (parentLi) {
            const link = parentLi.querySelector('a');
            if (link && link.textContent) {
                const menuName = link.textContent.trim();
                if (menuName) {
                    // Initial set
                    const isExpanded = btn.getAttribute('aria-expanded') === 'true';
                    btn.setAttribute('aria-label', `${isExpanded ? 'Collapse' : 'Expand'} ${menuName} submenu`);

                    // Observe changes to aria-expanded
                    const observer = new MutationObserver((mutations) => {
                        mutations.forEach(mutation => {
                            if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
                                const expanded = btn.getAttribute('aria-expanded') === 'true';
                                btn.setAttribute('aria-label', `${expanded ? 'Collapse' : 'Expand'} ${menuName} submenu`);
                            }
                        });
                    });
                    observer.observe(btn, { attributes: true, attributeFilter: ['aria-expanded'] });
                }
            }
        }
    });
});

// WCAG: Dynamically fix color contrast on specific brand green buttons 
// without affecting white or other colored buttons (like those on dark backgrounds)
document.addEventListener('DOMContentLoaded', () => {
    // These are the computed RGB values for the brand greens that fail contrast ratio
    // #13aa52, #13a952, #38b64a
    const badGreens = ['rgb(19, 170, 82)', 'rgb(19, 169, 82)', 'rgb(56, 182, 74)'];
    
    // Give external stylesheets a moment to apply
    setTimeout(() => {
        const buttons = document.querySelectorAll('.gspb-buttonbox, .wp-block-button__link');
        buttons.forEach(btn => {
            const computedStyle = window.getComputedStyle(btn);
            if (badGreens.includes(computedStyle.backgroundColor)) {
                btn.classList.add('a11y-fixed-green-btn');
            }
        });
    }, 100);
});

// WCAG: Close submenus on Escape key press
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' || e.key === 'Esc') {
        // Blur active element to handle focus-triggered submenus
        if (document.activeElement && document.activeElement.tagName !== 'BODY') {
            document.activeElement.blur();
        }
        
        // Handle hover-triggered submenus by hiding them temporarily
        const submenus = document.querySelectorAll('.sub-menu');
        submenus.forEach((submenu) => {
            submenu.style.display = 'none';
            submenu.style.opacity = '0';
            submenu.style.visibility = 'hidden';
            submenu.style.pointerEvents = 'none';
        });
        
        // Restore styles when the user interacts again
        const resetSubmenus = () => {
            submenus.forEach((submenu) => {
                submenu.style.display = '';
                submenu.style.opacity = '';
                submenu.style.visibility = '';
                submenu.style.pointerEvents = '';
            });
            document.removeEventListener('mousemove', resetSubmenus);
            document.removeEventListener('focusin', resetSubmenus);
        };
        
        document.addEventListener('mousemove', resetSubmenus);
        document.addEventListener('focusin', resetSubmenus);
    }
});

// WCAG: Add list semantics to Stackable columns block with accessible-sponsor-list class
const initAccessibleSponsorList = () => {
    const sponsorLists = document.querySelectorAll('.accessible-sponsor-list');
    
    sponsorLists.forEach(listContainer => {
        // Find the inner row that holds the columns
        const row = listContainer.querySelector('.stk-row');
        if (row) {
            row.setAttribute('role', 'list');
            
            // Find all direct columns inside the row
            const columns = row.querySelectorAll(':scope > .wp-block-stackable-column');
            columns.forEach(column => {
                column.setAttribute('role', 'listitem');
            });
        }
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccessibleSponsorList);
} else {
    initAccessibleSponsorList();
}